// 에러 타입별 사용자 친화적 메시지
const ERROR_MESSAGES = {
  // Firebase Auth 에러
  'auth/user-not-found': '사용자를 찾을 수 없습니다.',
  'auth/wrong-password': '잘못된 비밀번호입니다.',
  'auth/invalid-email': '유효하지 않은 이메일 주소입니다.',
  'auth/weak-password': '비밀번호는 6자 이상이어야 합니다.',
  'auth/email-already-in-use': '이미 사용 중인 이메일입니다.',
  'auth/requires-recent-login': '다시 로그인해주세요.',
  'auth/network-request-failed': '네트워크 연결을 확인해주세요.',
  
  // Firestore 에러
  'permission-denied': '권한이 없습니다.',
  'not-found': '요청한 데이터를 찾을 수 없습니다.',
  'already-exists': '이미 존재하는 데이터입니다.',
  'resource-exhausted': '할당량을 초과했습니다.',
  'failed-precondition': '작업을 수행할 수 없는 상태입니다.',
  'aborted': '작업이 중단되었습니다.',
  'out-of-range': '유효하지 않은 범위입니다.',
  'unimplemented': '지원하지 않는 기능입니다.',
  'internal': '내부 오류가 발생했습니다.',
  'unavailable': '서비스를 사용할 수 없습니다.',
  'data-loss': '데이터 손실이 발생했습니다.',
  
  // 기본 에러
  'default': '오류가 발생했습니다. 다시 시도해주세요.'
};

// 에러 로깅 (프로덕션에서는 에러 추적 서비스로 전송)
export const logError = (error, context = {}) => {
  if (process.env.NODE_ENV === 'development') {
    console.error('Error:', error);
    console.error('Context:', context);
  } else {
    // 프로덕션에서는 Sentry, LogRocket 등으로 전송
    // 예: Sentry.captureException(error, { extra: context });
  }
};

// Firebase 에러를 사용자 친화적 메시지로 변환
export const getErrorMessage = (error) => {
  if (!error) return ERROR_MESSAGES.default;
  
  // Firebase Auth 에러
  if (error.code && ERROR_MESSAGES[error.code]) {
    return ERROR_MESSAGES[error.code];
  }
  
  // Firestore 에러
  if (error.message) {
    const lowerMessage = error.message.toLowerCase();
    for (const [key, value] of Object.entries(ERROR_MESSAGES)) {
      if (lowerMessage.includes(key)) {
        return value;
      }
    }
  }
  
  return ERROR_MESSAGES.default;
};

// 에러 처리 래퍼 함수
export const handleError = (error, customMessage = null, context = {}) => {
  logError(error, context);
  return customMessage || getErrorMessage(error);
};

// 비동기 함수 에러 처리 래퍼
export const withErrorHandler = async (asyncFn, options = {}) => {
  const { 
    onError = null, 
    customMessage = null, 
    context = {},
    showNotification = true 
  } = options;
  
  try {
    return await asyncFn();
  } catch (error) {
    const errorMessage = handleError(error, customMessage, context);
    
    if (onError) {
      onError(error, errorMessage);
    }
    
    if (showNotification) {
      // 여기서 toast 알림 등을 표시할 수 있습니다
      // 예: toast.error(errorMessage);
    }
    
    throw error; // 필요한 경우 에러를 다시 throw
  }
};

// React 컴포넌트용 에러 바운더리 props
export const getErrorBoundaryProps = (componentName) => ({
  FallbackComponent: ({ error, resetError }) => (
    <div className="p-6 bg-red-50 border border-red-200 rounded-lg">
      <h2 className="text-xl font-bold text-red-700 mb-2">오류가 발생했습니다</h2>
      <p className="text-red-600 mb-4">{getErrorMessage(error)}</p>
      <button
        onClick={resetError}
        className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
      >
        다시 시도
      </button>
    </div>
  ),
  onError: (error) => logError(error, { component: componentName })
});